import { getResourceStringsAsync } from "../localization/getResourceStringsAsync";
import { partnerReducer } from "../redux/reducers/rootReducer";
import { partnerSagas } from "../redux/sagas/rootSagas";

export const getResourceStrings = getResourceStringsAsync;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const redux: any = {
  reducer: partnerReducer,
  sagas: partnerSagas,
};
